import axios from 'axios';
import { Config } from '../config';
import { AssociationDto, AssociationsRequest } from '../model/association.dto';

export class AssociationApi {
    public async associationList(accessToken: string, name: string, userNumber: string, phoneNumber: string, belong:string, memberLevel:string, offset?: number, limit?: number): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/association/membership`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const params = {
                name: name,
                membership_number: userNumber,
                phone_number: phoneNumber,
                association_name: belong,
                position: memberLevel,
                offset: offset,
                limit: limit,
            };
            const res = await axios.get(url, { headers, params });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async associationAdd(accessToken: string, dto: AssociationDto | null): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/association/membership`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.post(url, dto, { headers });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async associationsAdd(accessToken: string, dto: AssociationsRequest | null): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/association/membership/list`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.post(url, dto, { headers });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async putAssociation(accessToken: string, dto: AssociationDto): Promise<void> {
        try {
            const url = `${Config.API_URL}/console/association/membership`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            await axios.put(url, dto, { headers });
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async delAssociation(accessToken: string, checkItems: number[]): Promise<void> {
        try {
            const url = `${Config.API_URL}/console/association/membership`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            await Promise.all(checkItems.map(async (id) => {
                const params = {
                    ids: id
                };    
                await axios.delete(url, { headers, params });
            }));
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async duplicateHits(accessToken: string, userNumber: string): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/association/membership/check/${userNumber}`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const res = await axios.get(url, { headers });
            return res.data.result;
        } catch (error) {
            throw error;
        }
    }

    public async associationSearch(accessToken: string, name: string, userNumber: string, phoneNumber: string, belong:string, memberLevel:string, offset?:number, limit?:number): Promise<any[]> {
        try {
            const url = `${Config.API_URL}/console/association/membership`;
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            };
            const params = {
                name: name,
                membership_number: userNumber,
                phone_number: phoneNumber,
                association_name: belong,
                position: memberLevel,
                offset: offset,
                limit: limit,
            };
            const res = await axios.get(url, { headers, params });
            return res.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
}
